import React, { createContext, useRef, useEffect, useContext, useState } from 'react'
import { RendererContext } from '@/components/FURenderkit'
import { Button, ImageViewer, Modal, Popup } from 'antd-mobile'
import { AvatarContext } from '@/components/RenderComp/Avatar'

const ImgCaptureBtn = (props) => {
    const { renderer } = useContext(RendererContext)
    const handleSaveAndShare = async () => {
        const imgDataUrl = await printShot()
        Modal.show({
            content: <></>,
            image: imgDataUrl,
            showCloseButton: true,
            actions: [],
        })
    }

    const printShot = () => {
        // 临时画布 在截图时对画布区域进行遮盖
        const tmpCanvas = document.createElement("canvas")
        let parentNode = document.getElementById(
            "fu-renderkit-container"
        ) as HTMLElement
        tmpCanvas.style.width = "100%"
        tmpCanvas.style.height = "100%"
        tmpCanvas.style.position = "absolute"
        tmpCanvas.style.left = '0'
        tmpCanvas.style.top = '0'
        return new Promise<string>((resolve, reject) => {
            if (!renderer) return reject('renderer 错误！')
            renderer.captureImage(
                {
                    width: 400,
                    height: 700,
                    tmpCanvas,
                },
                (nextSibling, done) => {
                    parentNode.insertBefore(tmpCanvas, nextSibling)
                    done((dataurl) => {
                        resolve(dataurl)
                        parentNode.removeChild(tmpCanvas)
                    })
                }
            )
        })
    }

    return (
        <Button
            {...props}
            onClick={handleSaveAndShare}
        >
            快照
        </Button>
    )
}

export default ImgCaptureBtn
